/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/20/19
 * Time: 2:08 PM
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as actionCreator from "../../../store/Action";
import './Delay.scss';
// import {PropagateLoader} from "react-spinners";

class App extends Component {
  state = {
    loading: true
  };

  render() {

    let show = null;
    if (this.props.is_spin) {
      show = <div className={"delay-form"}>
        {/*<div className="ant-modal-mask" style={{background: 'rgba(239, 239, 239, 0.4)'}}>*/}
        {/*</div>*/}

        {/*<div tabIndex="-1" style={{zIndex: '10000'}} className="ant-modal-wrap vertical-center-modal"*/}
             {/*role="dialog">*/}
          {/*<div className={"wrap-sweet-loading"}>*/}
            {/*<div className='sweet-loading'>*/}
              {/*<PropagateLoader*/}
                {/*sizeUnit={"px"}*/}
                {/*size={this.props.size ? this.props.size : 15}*/}
                {/*color={this.props.color ? this.props.color : '#0085ca'}*/}
                {/*loading={this.state.loading}*/}
              {/*/>*/}
            {/*</div>*/}

          {/*</div>*/}
        {/*</div>*/}
        <div className="ui segment" id="data-fetch-loader" >
          <div className="ui active inverted dimmer">
            <div className="ui text loader">
            </div>
          </div>
          <p/>
        </div>
      </div>
    } else {
      show = null
    }

    return show
  }
}

const barStyle = {
  color: '#89dda7',
  left: '46%',
  position: 'absolute',
  top: '43%'
}

const mapStateToProps = (state) => ({
  // popup handling
  is_spin: state.spinnerReducer.is_spin,

});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
